import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import { memo } from "react";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import FormNumberField from "components/FormNumberField";

/* eslint-disable react/prop-types */

const countryOptions = [
  { value: "Việt Nam", label: "Việt Nam" },
  { value: "Lào", label: "Lào" },
  { value: "Trung Quốc", label: "Trung Quốc" },
];

function Fields2({ formData }) {
  const { formField2, values, errors, touched } = formData;
  const {
    countryName,
    carrierName,
    year,
    supplementaryForThe,
    firstTime, 
    vehicleName,
    taxPayerInsteadId,
    taxPayerInstead
  } =
    formField2;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
      <Grid item xs={4} style={{ paddingTop: 0 }}>
        <FormNumberField
            name={year.name}
            label={year.label}
            value={values.year}
            error={errors.year && touched.year}
            success={
              values.year?.toString().length > 0 && !errors.year
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={carrierName.name}
            label={carrierName.label}
            value={values.carrierName}
            error={errors.carrierName && touched.carrierName}
            success={
              values.carrierName?.toString().length > 0 && !errors.carrierName
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={countryOptions}
            type={countryName.type}
            label={countryName.label}
            name={countryName.name}
            value={values.countryName}
            placeholder={countryName.placeholder}
            error={errors.countryName && touched.countryName}
            success={values.countryName.length > 0 && !errors.countryName}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={vehicleName.name}
            label={vehicleName.label}
            value={values.vehicleName}
            error={errors.vehicleName && touched.vehicleName}
            success={
              values.vehicleName?.toString().length > 0 && !errors.vehicleName
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxPayerInstead.name}
            label={taxPayerInstead.label}
            value={values.taxPayerInstead}
            error={errors.taxPayerInstead && touched.taxPayerInstead}
            success={values.taxPayerInstead?.toString().length > 0 && !errors.taxPayerInstead}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxPayerInsteadId.name}
            label={taxPayerInsteadId.label}
            value={values.taxPayerInsteadId}
            error={errors.taxPayerInsteadId && touched.taxPayerInsteadId}
            success={values.taxPayerInsteadId?.toString().length > 0 && !errors.taxPayerInsteadId}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(Fields2);
